import { useQuery } from '@tanstack/react-query';

import { api } from '../api/endpoints';

// useLeadStatusLabels: Bezeichnungen der Lead-Status („Termin vereinbart“ statt APPOINTMENT), gleicher Cache wie die Leadliste.
export function useLeadStatusLabels(): Record<string, string> {
  const statuses = useQuery({ queryKey: ['lead-statuses'], queryFn: ({ signal }) => api.leadStatuses(signal), staleTime: 60 * 60_000 });
  return Object.fromEntries((statuses.data?.items ?? []).map((s) => [s.code, s.label]));
}

// statusSummary: ältere Chronik-Einträge enthalten den Code („Status: APPOINTMENT“) – zur Anzeige die Bezeichnung einsetzen.
export function statusSummary(summary: string, labels: Record<string, string>): string {
  const code = /^Status: ([A-Z_]+)$/.exec(summary)?.[1];
  return code && labels[code] ? `Status: ${labels[code]}` : summary;
}
